import { render, staticRenderFns } from "./CardSpecimenTree.vue?vue&type=template&id=7fdcee48"
import script from "./CardSpecimenTree.vue?vue&type=script&lang=js"
export * from "./CardSpecimenTree.vue?vue&type=script&lang=js"
import style0 from "./CardSpecimenTree.vue?vue&type=style&index=0&id=7fdcee48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports